import sliders    from './utils/sliders.js';
import MobileMenu from './components/MobileMenu.js';
import search     from './utils/search.js';
import modal      from './utils/modal.js';
import accordion  from './utils/accordion.js';
import scrollTo   from './utils/scrollTo.js';
import Anim       from './components/Anim.js';
import cookies      from './utils/cookies.js';

// Init
function init() {
	sliders();
	search();
	modal();
	accordion();
	scrollTo();

	// eslint-disable-next-line no-new
	new MobileMenu();

	Anim();

    cookies();

    document.querySelectorAll('.modal').forEach(modal => {
        const btns = modal.querySelectorAll('[data-content="btn"]');
        btns.forEach(btn => {
            btn.addEventListener('click', () => {
                const blocks = modal.querySelectorAll('[data-content="test"]');
                blocks.forEach(block => {
                    block.classList.toggle('is-hide');
                });
            });
        });

    });
}

(function () {
	init();
}());
